const APP_TYPE_COURT_RENTAL = 6;
let appType = null;

export function setAppType(newAppType) {
  appType = newAppType;
}

export function getAppType() {
  return appType;
}

export function isAppTypeCourtRental() {
  return APP_TYPE_COURT_RENTAL === appType;
}
